let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3ioZJ")).then(() => parcelRequire('5vSwz'));